/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SBE SMS API
 * SMS API. AccessTokenGuard 보호 라우트는 Authorization: Bearer <jwt> 가 필요.
 * OpenAPI spec version: 1.0
 */

export type DeliveryStatus = typeof DeliveryStatus[keyof typeof DeliveryStatus];


export const DeliveryStatus = {
  Pending: 'Pending',
  Sending: 'Sending',
  Sent: 'Sent',
  Delivered: 'Delivered',
  Failed: 'Failed',
  Rejected: 'Rejected',
} as const;
